import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { authThunk } from "./auth.thunk";
import { TImageSignatures, TPrograms, TTokens } from "./types";

type TInitialState = {
  isUserLoggedIn: boolean;
  loading: boolean;
  programs: TPrograms | null;
  imageSignatures: TImageSignatures | null;
  imageSignatureParams: string | null;
  tokens: TTokens | null;
  user: any | null;
  cognitoUser: any | null;
};

const initialState: TInitialState = {
  isUserLoggedIn: false,
  loading: false,
  programs: null,
  imageSignatures: null,
  imageSignatureParams: null,
  tokens: null,
  user: null,
  cognitoUser: null
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    userLoggedIn: (state) => {
      state.isUserLoggedIn = true;
    },
    setTokens: (state, action) => {
      state.tokens = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setCognitoUser: (state, action) => {
      state.cognitoUser = action.payload;
    },
  },
  extraReducers(builder) {
    // Login Reducers
    builder.addCase(authThunk.getLoginSections.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(authThunk.getLoginSections.fulfilled, (state, action) => {
      const payload = action.payload;
      state.programs = payload;
    });

    builder.addCase(authThunk.getLoginSections.rejected, (state, action) => {
      state.loading = false;
      state.programs = null;
    });

    // Login Reducers END

    // Image Signatures

    builder.addCase(authThunk.getImageSignatures.pending, (state) => {
      state.loading = false;
    });

    builder.addCase(authThunk.getImageSignatures.fulfilled, (state, action) => {
      state.loading = false;
      state.imageSignatures = action.payload;
      state.imageSignatureParams = new URLSearchParams(
        action.payload
      ).toString();
    });

    // Image Signatures END

    builder.addMatcher(
      isAnyOf(
        authThunk.getLoginSections.fulfilled,
        authThunk.getLoginSections.rejected
      ),
      (state) => {
        state.loading = false;
      }
    );
  },
});

export const authActions = {
  actions: authSlice.actions,
};

const authReducer = authSlice.reducer;
export default authReducer;
